"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userGroups = exports.remove = exports.setLive = exports.update = exports.create = exports.get = exports.list = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var query_string_1 = tslib_1.__importDefault(require("query-string"));
var base = '/api/changelog';
function list(query) {
    var queryParams = query_string_1.default.stringify(query);
    return api_1.default.get("".concat(base, "?").concat(queryParams)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.list = list;
function get(id) {
    return api_1.default.get("".concat(base, "/").concat(id)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.get = get;
function create(payload) {
    return api_1.default.post(base, payload).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.create = create;
function update(id, payload) {
    return api_1.default.patch("".concat(base, "/").concat(id), payload).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.update = update;
function setLive(id, isLive) {
    return api_1.default.patch("".concat(base, "/").concat(id, "/live"), { isLive: isLive }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.setLive = setLive;
function remove(id) {
    return api_1.default.delete("".concat(base, "/").concat(id)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.remove = remove;
function userGroups(q) {
    return api_1.default
        .get("".concat(base, "/user-groups"), { params: q ? { q: q } : {} })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.userGroups = userGroups;
var api = { list: list, get: get, create: create, update: update, setLive: setLive, remove: remove, userGroups: userGroups };
exports.default = api;
